import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_ORDERS_OPERATIONAL_DASHBOARD = `${URL_RETAILER_SCOPED}/orders-operational-dashboard`
export const URL_ORDERS_OPERATIONAL_DASHBOARD_DASHBOARD_PAGE = `${URL_ORDERS_OPERATIONAL_DASHBOARD}/dashboard`

const URL_ORDERS_OPERATIONAL_DASHBOARD_TRACKING_PAGE = `${URL_ORDERS_OPERATIONAL_DASHBOARD}/tracking/:orderType/:orderId`
const URL_ORDERS_OPERATIONAL_DASHBOARD_DETAILS_TAB = `${URL_ORDERS_OPERATIONAL_DASHBOARD}/details/:orderType/:orderId`
const URL_ORDERS_OPERATIONAL_DASHBOARD_PICKUP_DETAILS_PAGE = `${URL_ORDERS_OPERATIONAL_DASHBOARD}/pickup/:orderId`

// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'orders-operational-dashboard'>
  | DashRouteType<'orders-operational-dashboard-tracking-page'>
  | DashRouteType<'orders-operational-dashboard-dashboard-page'>
  | DashRouteType<'orders-operational-dashboard-details-tab'>
  | DashRouteType<'orders-operational-dashboard-pickup-details-page'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'orders-operational-dashboard': URL_ORDERS_OPERATIONAL_DASHBOARD,
  'orders-operational-dashboard-tracking-page': URL_ORDERS_OPERATIONAL_DASHBOARD_TRACKING_PAGE,
  'orders-operational-dashboard-details-tab': URL_ORDERS_OPERATIONAL_DASHBOARD_DETAILS_TAB,
  'orders-operational-dashboard-pickup-details-page':
    URL_ORDERS_OPERATIONAL_DASHBOARD_PICKUP_DETAILS_PAGE,
  'orders-operational-dashboard-dashboard-page': URL_ORDERS_OPERATIONAL_DASHBOARD_DASHBOARD_PAGE,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
// @hygen:inject scoped-urls
